var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiMagic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1667 11.667L16.3069 13.9904C15.1796 17.037 14.6159 18.5603 13.5046 19.6717C12.3934 20.7828 10.8701 21.3465 7.82342 22.474L5.5 23.3337L7.82342 24.1933C10.8701 25.3208 12.3934 25.8845 13.5046 26.9957C14.6159 28.107 15.1796 29.6303 16.3069 32.6768L17.1667 35.0003L18.0263 32.6768C19.1538 29.6303 19.7175 28.107 20.8287 26.9957C21.94 25.8845 23.4633 25.3208 26.5098 24.1933L28.8333 23.3337L26.5098 22.474C23.4633 21.3465 21.94 20.7828 20.8287 19.6717C19.7175 18.5603 19.1538 17.037 18.0263 13.9904L17.1667 11.667Z",
    stroke: "#34B474",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 5L30.1315 5.99575C29.6483 7.30145 29.4068 7.95432 28.9305 8.43055C28.4543 8.9068 27.8015 9.14838 26.4958 9.63153L25.5 10L26.4958 10.3685C27.8015 10.8516 28.4543 11.0932 28.9305 11.5694C29.4068 12.0457 29.6483 12.6985 30.1315 14.0042L30.5 15L30.8685 14.0042C31.3517 12.6985 31.5932 12.0457 32.0695 11.5694C32.5457 11.0932 33.1985 10.8516 34.5042 10.3685L35.5 10L34.5042 9.63153C33.1985 9.14838 32.5457 8.9068 32.0695 8.43055C31.5932 7.95432 31.3517 7.30145 30.8685 5.99575L30.5 5Z",
    stroke: "#34B474",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiMagic);
export default __webpack_public_path__ + "static/media/AI-Magic.b105e49cdeb34fe89374a45d2d4d3931.svg";
export { ForwardRef as ReactComponent };